class OhsModulePermissions {
  view: boolean;

  create: boolean;

  edit: boolean;

  edit_roll?: boolean;

  signoff: boolean;

  signoff_history: boolean;

  archive: boolean;

  archive_prose?: boolean;

  create_prose?: boolean;

  delete: boolean;

  allocate: boolean;

  assign_task: boolean;

  form_create: boolean;

  form_edit: boolean;

  form_archive: boolean;

  form_export: boolean;

  pricing: boolean;

  copy: boolean;

  delete_one_off_child: boolean;

  lti_captured_hours_edit?: boolean;

  lti_captured_hours_view?: boolean;

  lti_captured_report_view?: boolean;

  lti_import?: boolean;

  invite?: boolean;

  constructor(flag: boolean) {
    this.view = flag;
    this.create = flag;
    this.edit = flag;
    this.signoff = flag;
    this.signoff_history = flag;
    this.archive = flag;
    this.delete = flag;
    this.allocate = flag;
    this.assign_task = flag;
    this.form_archive = flag;
    this.form_create = flag;
    this.form_edit = flag;
    this.form_export = flag;
    this.pricing = flag;
    this.copy = flag;
    this.delete_one_off_child = flag;
    this.lti_captured_hours_edit = flag;
    this.lti_captured_hours_view = flag;
    this.lti_captured_report_view = flag;
    this.lti_import = flag;
    this.invite = flag;
  }
}

export default OhsModulePermissions;
